// src/pages/FAQsPage.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebaseConfig';
import {
  collection,
  addDoc,
  onSnapshot,
  serverTimestamp,
  deleteDoc,
  doc,
} from 'firebase/firestore';

const FAQsPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState('');

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'userFAQs'), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFaqs(data);
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async () => {
    if (!question.trim()) return alert('Please type a question.');

    await addDoc(collection(db, 'userFAQs'), {
      question,
      answer: '',
      createdAt: serverTimestamp(),
    });

    setQuestion('');
    alert('Question submitted. You’ll see the response here once available.');
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm('Are you sure you want to delete this question?');
    if (!confirm) return;

    try {
      await deleteDoc(doc(db, 'userFAQs', id));
      alert('Question deleted.');
    } catch (error) {
      console.error('Delete error:', error.message);
      alert('Failed to delete question.');
    }
  };

  const backgroundImage =
    'https://static.vecteezy.com/system/resources/thumbnails/024/494/104/small_2x/abstract-light-background-blue-background-with-waves-free-photo.jpg';

  const leftImage =
    'https://www.shutterstock.com/shutterstock/photos/1842408310/display_1500/stock-vector-lost-and-found-service-concept-with-cartoon-characters-loosing-baggage-while-airline-flight-1842408310.jpg';

  const rightImage =
    'https://img.freepik.com/premium-vector/cartoon-young-man-returning-lost-wallet-lost-found-service_341509-1088.jpg?w=360';

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'row',
        padding: '2rem',
        position: 'relative',
        flexWrap: 'wrap',
      }}
    >
      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .faq-layout {
            flex-direction: column !important;
          }
          .side-image {
            display: none !important;
          }
          .faq-content {
            width: 100% !important;
          }
        }
      `}</style>

      {/* White overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          zIndex: 1,
        }}
      />

      {/* Left Image */}
      <div
        className="side-image"
        style={{
          flex: 1,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <img
          src={leftImage}
          alt="Lost Item"
          style={{
            width: '220px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          }}
        />
      </div>

      {/* FAQ Main Content */}
      <div
        className="faq-content"
        style={{
          flex: 2,
          zIndex: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        <h2 style={{ textAlign: 'center', color: '#1B3B6F', marginBottom: '2rem' }}>
          Frequently Asked Questions
        </h2>

        <div style={{ marginBottom: '2rem' }}>
          <textarea
            placeholder="Ask a question..."
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            style={{
              width: '100%',
              height: '80px',
              padding: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1rem',
            }}
          />
          <button
            onClick={handleSubmit}
            style={{
              backgroundColor: '#1B3B6F',
              color: 'white',
              padding: '0.5rem 1.2rem',
              borderRadius: '5px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Submit Question
          </button>
        </div>

        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              marginBottom: '1.5rem',
              background: '#f9f9f9',
              padding: '1rem',
              borderRadius: '8px',
              position: 'relative',
            }}
          >
            <h4 style={{ color: '#333' }}>{faq.question}</h4>
            <p style={{ color: '#555' }}>
              {faq.answer ? (
                <strong style={{ color: 'green' }}>Admin: {faq.answer}</strong>
              ) : (
                <em style={{ color: '#999' }}>Awaiting admin response...</em>
              )}
            </p>
            {/* Delete Button */}
            <button
              onClick={() => handleDelete(faq.id)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: 'red',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                cursor: 'pointer',
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      {/* Right Image */}
      <div
        className="side-image"
        style={{
          flex: 1,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <img
          src={rightImage}
          alt="Found Item"
          style={{
            width: '220px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          }}
        />
      </div>
    </div>
  );
};

export default FAQsPage;
